import { Flex } from "@chakra-ui/react"
import { AuthPageStyling } from "src/context/types"
import { AvatarDimensionality } from "src/recoil/atoms/avatars"
import { AvatarConfig } from "src/recoil/atoms/avatars/types"
import PerspectiveBtn from "./perspective-btn"
import { PerspectiveBtnAlt } from "./PerspectiveBtnAlt"

type AvatarCardHoverOverlayProps = {
  avatarConfig: AvatarConfig
  branding: AuthPageStyling
  openShow: (dimensionality: AvatarDimensionality) => void
  openShowInNewTab: () => void
  isRoomloading: boolean
  isCurrentRoomLoading: boolean
  btnText: string
}

export const AvatarCardHoverOverlay = ({
  branding,
  openShow,
  avatarConfig
}: AvatarCardHoverOverlayProps) => {
  return (
    <Flex
      width="full"
      height="full"
      backgroundColor="rgba(51,51,51,0.8)"
      justify="center"
      align="center"
      userSelect="none"
      direction="column"
      gap=".75rem"
      color={branding?.authPageButtonMouseoverBackgroundColor ?? "#24A840"}
    >
      {!!avatarConfig.avatarId3d && (
        <PerspectiveBtn
          type="3D"
          onClick={() => openShow(AvatarDimensionality.threeDimensional)}
          borderRadius="9999px"
        />
      )}
      {!!avatarConfig.avatarId && (
        <PerspectiveBtn
          type="2D"
          onClick={() => openShow(AvatarDimensionality.twoDimensional)}
          borderRadius="9999px"
        />
      )}
    </Flex>
  )
}
